<template>
  <div
    @click="takePhoto()"
    v-if="config?.camera?.status?.camera_mode === 0"
    class="aspect-square border-3 border-white hover:border-flyingeye-light active:opacity-50 p-1 w-8 rounded-full mr-2 cursor-pointer"
  >
    <div class="bg-error w-full h-full rounded-full"></div>
  </div>
</template>
<script>
import API from "@/utils/API.js";
export default {
  name: "Mode_Camera",
  props: {
    config: {
      config: Object,
      video: Object,
    },
  },
  setup() {
    return {};
  },

  methods: {
    async takePhoto() {
      let data = await API.put("cameraphototake", {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: "Photo",
      };
    },
  },
};
</script>
